import { render, staticRenderFns } from "./brainCardiovascular.vue?vue&type=template&id=3361ca1a"
import script from "./brainCardiovascular.vue?vue&type=script&lang=js"
export * from "./brainCardiovascular.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3361ca1a')) {
      api.createRecord('3361ca1a', component.options)
    } else {
      api.reload('3361ca1a', component.options)
    }
    module.hot.accept("./brainCardiovascular.vue?vue&type=template&id=3361ca1a", function () {
      api.rerender('3361ca1a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/hea/bcs/brainCardiovascular.vue"
export default component.exports